// ----------------------------------------------------------------------------
// Component: Anchor Links
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_anchor-links.scss';

// -------------------------------------
// Variables
// -------------------------------------
var ANCHOR_SELECTOR = '.anchor-links-wrap';
var ANCHOR_LINK_SELECTOR = '.anchor-link';
var ANCHOR_LINKS_CONTAINER = '.anchor-links-container';
var ACTIVE_CLASS = 'active';
document.addEventListener('DOMContentLoaded', () => {
  var anchorWrap = document.querySelector(ANCHOR_SELECTOR);
  var anchorLinks = [...document.querySelectorAll(ANCHOR_LINK_SELECTOR)];
  var anchorContainer = anchorWrap === null || anchorWrap === void 0 ? void 0 : anchorWrap.querySelector(ANCHOR_LINKS_CONTAINER);
  if (!anchorWrap || !anchorLinks.length || !anchorContainer) return;
  var getHeaderOffset = () => anchorContainer.offsetHeight || 0;
  var setScrollPaddingTop = () => {
    var headerOffset = getHeaderOffset();
    document.documentElement.style.setProperty('--scroll-padding-top', "".concat(headerOffset, "px"));
    document.documentElement.style.setProperty('--header-height', "".concat(headerOffset, "px"));
  };
  var setActiveLink = targetId => {
    anchorLinks.forEach(link => {
      link.classList.toggle(ACTIVE_CLASS, link.getAttribute('href') === "#".concat(targetId));
    });
  };
  var sections = anchorLinks.map(link => {
    var href = link.getAttribute('href');
    return href !== null && href !== void 0 && href.startsWith('#') ? document.querySelector(href) : null;
  }).filter(Boolean).filter((section, index, arr) => arr.indexOf(section) === index);
  if (!sections.length) return;
  var updateActiveLink = () => {
    var _closestSection;
    var triggerLine = getHeaderOffset();
    var closestSection = null;
    var closestDistance = Infinity;
    sections.forEach(section => {
      var rect = section.getBoundingClientRect();
      if (rect.bottom <= triggerLine) return;
      var distance = Math.abs(rect.top - triggerLine);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSection = section;
      }
    });
    if ((_closestSection = closestSection) !== null && _closestSection !== void 0 && _closestSection.id) {
      setActiveLink(closestSection.id);
    }
  };
  anchorLinks.forEach(link => {
    link.addEventListener('click', () => {
      var _link$getAttribute;
      var targetId = (_link$getAttribute = link.getAttribute('href')) === null || _link$getAttribute === void 0 ? void 0 : _link$getAttribute.slice(1);
      if (targetId) {
        requestAnimationFrame(() => setActiveLink(targetId));
      }
    });
  });
  var handleUpdate = () => {
    setScrollPaddingTop();
    updateActiveLink();
  };
  window.addEventListener('scroll', updateActiveLink, {
    passive: true
  });
  window.addEventListener('resize', handleUpdate);
  handleUpdate();
});